import { FEELIX_THEMES } from '../../../constants';

export const getStyleProps = (theme: string) => {
  const shouldUseModernStyle = [FEELIX_THEMES.MODERN, FEELIX_THEMES.PARTNER].includes(theme);
  const shouldUseCommonStyle = theme === FEELIX_THEMES.COMMON;

  return {
    container: {
      paddingTop: 'sm',
      paddingBottom: 'sm',
      paddingLeft: 'md',
      paddingRight: 'md',
      width: '100%',
      ...(shouldUseModernStyle && {
        paddingTop: 'clear',
        paddingLeft: 'lg',
        paddingRight: 'lg',
        paddingBottom: '2xs'
      }),
      ...(shouldUseCommonStyle && {
        paddingLeft: 'xs'
      })
    },
    rowOne: {
      as: 'span',
      display: 'block',
      fontSize: 'xs',
      ...(shouldUseModernStyle && {
        fontSize: 'sm',
        marginTop: 'sm'
      })
    },
    rowTwo: {
      level: '2',
      marginBottom: '5xs',
      ...(theme === FEELIX_THEMES.SOLO && {
        marginBottom: '4xs',
        marginTop: '4xs'
      }),
      ...(shouldUseCommonStyle && {
        marginBottom: 'clear',
        marginTop: 'md',
        paddingLeft: '5xs',
        fontSize: 'xl'
      })
    }
  };
};
